import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { VerifyClientList } from "../models/client/verify/verifyClientList";
import { GenericResponseDto } from "../models/generic-response.dto";
import { VerifyProspectRequest } from "../models/prospect/verifyprospect/verifyProspectRequest";

@Injectable({
  providedIn: "root",
})
export class VerifyClientService {
  private clientManagementBaseURL = environment.baseUrl + "/ClientManagement";

  constructor(private _http: HttpClient) {}

  verifyClientData(
    payload: VerifyProspectRequest
  ): Observable<GenericResponseDto<VerifyClientList[]>> {
    return this._http.post<GenericResponseDto<VerifyClientList[]>>(
      this.clientManagementBaseURL + "/VerifyClients",
      payload
    );
  }
}
